// extracted by mini-css-extract-plugin
export default {"Header":"io312Sv3KJSP8KR4CL4t","DeleteButton":"EzLhdw0WAjoaYSOat11h","RevokeButton":"sm9mg8fXXCj37dI3C78J"};